import { useTranslation } from 'react-i18next'

import { getFileItems } from '../../../../../api'
import { useUk } from '../../../../../hooks'
import {
  ATTACH_ACTION_SELECT_ACTION_FILE,
  ATTACH_ACTION_SELECT_FILE_FROM_STORAGE,
} from '../../../../AttachActionSelect'
import { FileAttachItemsModal } from '../../../../File'
import {
  EMAIL_CREATION_FORM_ACTION_ATTACH_REQUEST_FILE,
  EMAIL_CREATION_FORM_ACTION_ATTACH_TEMPLATE,
} from '../../EmailCreationForm.constants'
import { getEmailFormAttachActions } from '../../EmailCreationForm.utils'

import { getMergedStorageFiles } from './useAttach.utils'

export function useAttach({
  requestFolderModalProps,
  selectedStorageFiles,
  onAttachFilesFromStorage,
  onCloseModal,
  onOpenGoogleTemplate,
  onSetModal,
}) {
  const { t } = useTranslation()

  const { directory_id: ukDocumentsFolder } = useUk()

  function handleOpenFileAttachItemsModal({ modalProps, onSubmit }) {
    onSetModal(
      <FileAttachItemsModal
        {...modalProps}
        ButtonRemove={false}
        getData={getFileItems}
        initialValues={selectedStorageFiles}
        onClose={onCloseModal}
        onSubmit={onSubmit}
      />
    )
  }

  function handleAttachDocumentsFolderFiles(files) {
    onAttachFilesFromStorage(
      getMergedStorageFiles({
        acceptedFiles: files,
        prevFiles: selectedStorageFiles,
      })
    )
  }

  function handleAttachRequestFolderFiles(files) {
    onAttachFilesFromStorage(
      getMergedStorageFiles({
        acceptedFiles: files,
        prevFiles: selectedStorageFiles,
        requestId: requestFolderModalProps.entityId,
      })
    )
  }

  function handleAttachAction(action) {
    switch (action.value) {
      case ATTACH_ACTION_SELECT_ACTION_FILE:
        // handling action in `AttachActionSelect`
        break

      case ATTACH_ACTION_SELECT_FILE_FROM_STORAGE:
        handleOpenFileAttachItemsModal({
          modalProps: { directoryId: ukDocumentsFolder },
          onSubmit: handleAttachDocumentsFolderFiles,
        })
        break

      case EMAIL_CREATION_FORM_ACTION_ATTACH_REQUEST_FILE:
        handleOpenFileAttachItemsModal({
          modalProps: requestFolderModalProps,
          onSubmit: handleAttachRequestFolderFiles,
        })
        break

      case EMAIL_CREATION_FORM_ACTION_ATTACH_TEMPLATE:
        onOpenGoogleTemplate()
        break

      default:
        return null
    }
  }

  const attachActionOptions = getEmailFormAttachActions({
    t,
    withRequestFolderAction: !!requestFolderModalProps,
  })

  return {
    attachActionOptions,
    handleAttachAction,
  }
}
